import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import api from "@/lib/api";
import { Packages, CtaStrip } from "@/components/sections/HomeSections";
import SEO from "@/components/SEO";

export default function Services() {
  const [services, setServices] = useState([]);
  useEffect(() => { api.get("/services").then(r => setServices(r.data)).catch(() => {}); }, []);

  return (
    <div data-testid="services-page" className="pt-32">
      <SEO title="Wedding Photography & Film Services" path="/services" description="Wedding photography, films, engagement sessions, destination weddings, drone moments and same-day social content — all built around your story." />
      <section className="section-pad pb-12 max-w-[1400px] mx-auto text-center">
        <div className="eyebrow">How We Can Help</div>
        <h1 className="font-serif text-5xl md:text-6xl font-light mt-4 tracking-tight">What We <em className="text-[#D4AF37] not-italic">Create</em></h1>
      </section>
      <section className="px-6 md:px-10 max-w-[1400px] mx-auto pb-16">
        {services.length === 0 ? (
          <div className="text-center text-white/40 py-16">No services published yet.</div>
        ) : (
          <div className="grid md:grid-cols-2 gap-6">
            {services.map(s => (
              <Link to={`/services/${s.slug}`} key={s.slug} className="relative aspect-[16/10] overflow-hidden group" data-testid={`service-card-${s.slug}`}>
                <img src={s.image} alt={s.name} className="w-full h-full object-cover transition-transform duration-1000 group-hover:scale-110" />
                <div className="absolute inset-0 bg-gradient-to-t from-black via-black/40 to-transparent" />
                <div className="absolute bottom-0 left-0 p-8">
                  <div className="eyebrow">What We Do</div>
                  <h3 className="font-serif text-3xl mt-1">{s.name}</h3>
                  <p className="text-white/70 text-sm mt-2 max-w-md">{s.tagline}</p>
                  <span className="inline-flex items-center gap-2 mt-4 text-[#D4AF37] text-xs tracking-[0.2em] uppercase">Learn More <ArrowRight size={12}/></span>
                </div>
              </Link>
            ))}
          </div>
        )}
      </section>
      <Packages />
      <CtaStrip />
    </div>
  );
}
